<template>
	<div class="ReCuratorContacts col-sm-6 col-md-5">
		<h4>Контакты</h4>
		<div class="avatarBlk author">
			<div class="photo"><img class="avatar" src="/img/placeholder.jpg" /></div>
		</div>
		<p>Имя Фамилия</p>
		<p class="description" > <!--:key="dc_index" v-if="dopContact.contact_group!='social' "-->
			<a href="#" class=""> <!--:class="[{'text-primary':dopContact.contact_group=='email'},{'text-success':dopContact.contact_group!='email'}]"-->
				<i class="d-inline-block tim-icons icon-email-85"></i> <!--v-if="dopContact.contact_group=='email'"-->
				<i class="d-inline-block icon-call"></i> <!--v-if="dopContact.contact_group=='phone'"-->
				<i class="d-inline-block tim-icons icon-send"></i> <!--v-if="dopContact.contact_group=='messanger'"-->
				<span>dopContact.contact_value</span>
			</a>
		</p>
	</div>
</template>

<script>

export default {
	name: "ReCuratorContacts",
	components: {
		
	},
	props: {
		findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
            type: String,
            default: '',
		},
		openContacts: {
			type: Boolean,
            default: false,
		},

	},
	data() {
		return {
			
		};
	},
	computed: {

	},
	methods: {

	},
	mounted() {
		
	}
};
</script>

<style scoped>
.ReCuratorContacts {
	display: flex; 
	flex-direction: column; 
	align-items: center; 
	padding: 15px; 
	border: 1px solid #01b0e0; 
	border-radius: 6px; 
	margin: 0px 15px 15px 0px; 
	word-break: break-all;}
.ReCuratorContacts .photo {display: flex; justify-content: center;}
.avatarBlk{width:200px;}
.avatarBlk .avatar{
	object-fit: contain;
	background-color: white;
}
.ReCuratorContacts >>> .avatar {
    width: 60px;
    height: 60px;
    overflow: hidden;
    border-radius: 50%;
    margin-bottom: 15px;
}
.ReCuratorContacts .card-user .author{margin-top: 0px;}


</style>
